import { Reducer } from 'redux';

const initialState = {};

const rootReducer: Reducer<typeof initialState> = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default rootReducer;